import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import Price from "./Price";
// import Ratings from "./Rating";
// import { Skeleton } from "@mui/material";

// https://keen-slider.io/examples
// https://www.npmjs.com/package/
// https://react-slick.neostack.com/
// using the thumbnail and lazy load

const NewItems = ({ bikes }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const settings = {
    infinite: true,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section id="recent" className="">
      <div className="container">
        <div className="row">
          <div className="section__title">
            <div className="text-center">
              <h2>New Items</h2>
              <div className="small-border bg-color-2"></div>
            </div>
          </div>

          {/* slider */}
          <div className="container">
            {loading ?
              <>
                <Slider {...settings}>
                  {bikes.map((data) => (
                    <div className="" key={data.id} data-aos="">
                      <div className="nft__item">
                        <div className="author_list_pp">
                          <Link
                            to={`/bikes/${data.id}`}
                            data-bs-toggle=""
                            data-bs-placement=""
                            title={`data.title`}
                          >
                            <img className="lazy" src={data.url} alt={data.title} />
                            <i className="fa fa-check"></i>
                          </Link>
                        </div>
                        {/* {data.expiryDate !== null ? <Countdown time={data.expiryDate} /> : <></>} */}
                        <div className="nft__item_wrap">
                          <div className="nft__item_extra">
                            <div className="nft__item_buttons">
                              <button>Buy Now</button>
                              <div className="nft__item_share">
                                <h4>Share</h4>
                                <a href="" target="_blank" rel="noreferrer">
                                  <i className="fa fa-facebook fa-lg"></i>
                                </a>
                                <a href="" target="_blank" rel="noreferrer">
                                  <i className="fa fa-twitter fa-lg"></i>
                                </a>
                                <a href="">
                                  <i className="fa fa-envelope fa-lg"></i>
                                </a>
                              </div>
                            </div>
                          </div>

                          <Link to={`/bikes/${data.id}`}>
                            <img
                              src={data.url}
                              className="lazy nft__item_preview"
                              alt={data.title}
                            />
                          </Link>
                        </div>
                        <div className="nft__item_info">
                          <Link to={`/bikes/${data.id}`}>
                            <h4>{data.title}</h4>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </>
              :
              <>
                <>
                  <div className="book__img--skeleton"></div>
                  <div className="skeleton book__title--skeleton"></div>
                  <div className="skeleton book__rating--skeleton"></div>
                  <div className="skeleton book__price--skeleton"></div>
                </>
                {/* <Slider {...settings}>
                  {new Array(4).fill(0).map((_, index) => (
                    <div className="px-2 sm:px-1" key={index}>
                      <div className="nft__item">
                        <div className="author_list_pp">
                          <Skeleton width={50} height={50} borderRadius={9999} />
                        </div>
                        <div className="absolute right-5 ">
                          <Skeleton width={60} height={14} borderRadius={10} />
                        </div>
                        <div className="nft__item_wrap">
                          <Skeleton width="100%" height={230} borderRadius={10} />
                        </div>
                        <div className="nft__item_info">
                          <Skeleton width={100} height={14} borderRadius={10} />
                          <div className="nft__item_price">
                            <Skeleton width={60} height={14} borderRadius={10} />
                          </div>
                          <div className="nft__item_like">
                            <Skeleton width={40} height={14} borderRadius={10} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider> */}
              </>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewItems;